import { IconButtonWrapper } from '@anm/components/buttons/IconButton';
import Tooltip from '@anm/components/Tooltip';
import getFromCdn from '@anm/helpers/getFromCdn';
import { blackFilter, flexCenter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: sticky;
  top: 100%;
  bottom: 20px;
  :hover {
    z-index: 10;
  }
  * {
    color: var(--blue_100);
  }
`;

export const Label = styled.label`
  cursor: pointer;
  display: block;
  min-height: 50px;
  border-radius: 5px;

  &:hover {
    background: #f4f6f7;
  }
`;
export const ButtonWrapper = styled(IconButtonWrapper)`
  height: 50px;
  line-height: 50px;
  padding: 0 19px 0 10px;
  pointer-events: none;
`;

export const CancelledLabel = styled(ButtonWrapper)`
  color: var(--error);
`;

const commonTooltipStyles = css`
  padding: 12px 20px;
  &:before {
    left: 45%;
  }
`;

export const ReplaceVideoTooltip = styled(Tooltip)`
  min-width: 258px;
  transform: translate(0, calc(-100% - 10px));
  ${commonTooltipStyles};
`;

export const CancelTooltip = styled(Tooltip)`
  min-width: 194px;
  transform: translate(40%, calc(-100%));
  ${commonTooltipStyles};
`;

export const TooltipText = styled.span`
  color: #fff;
  font-size: 14px;
`;

export const ProgressWrapper = styled.div`
  ${flexCenter}
  justify-content: space-between;
`;

export const ProgressValue = styled.span`
  font-size: 16px;
  line-height: 21px;
  color: #292a2b;
`;

export const ProgressPanel = styled.div`
  ${flexCenter};
`;

export const ProgressAnimation = styled.div`
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
  width: 50px;
  height: 50px;
  filter: ${blackFilter};
  animation: spin 0.7s infinite linear;
  background: url(${getFromCdn('images/icons/icon_replace.svg')}) no-repeat center / 24px;
`;

export const ButtonCancel = styled(IconButtonWrapper)`
  height: 50px;
  line-height: 50px;
  cursor: pointerl;
`;
